"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangeWrapper = void 0;
var React = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _utils = require("../../utils");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _dateRangePicker = require("../../utils/date-range-picker");
var _Button = require("../Button");
var _Card = require("../Card");
var _Dropdown = require("../Dropdown");
var _FocusManager = require("../FocusManager");
var _Icon = require("../Icon");
var _Calendar = require("./Calendar.js");
var _DateRangeWrapperModule = _interopRequireDefault(require("./DateRangeWrapper.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CalendarHeader = _ref => {
  let {
    date,
    marker,
    minDate,
    maxDate,
    setMonth,
    rangeStartMonth,
    rangeEndMonth,
    onClickNext,
    nextDisabled,
    prevDisabled,
    onClickPrevious
  } = _ref;
  const availableYears = (0, _utils.generateAvailableYears)({
    marker,
    minDate,
    maxDate,
    rangeStartMonth,
    rangeEndMonth
  });
  const availableMonths = (0, _utils.getAvailableMonths)({
    marker,
    minDate,
    maxDate,
    rangeStartMonth,
    rangeEndMonth
  });
  return /*#__PURE__*/React.createElement("div", {
    className: _DateRangeWrapperModule.default.calendarHeader
  }, /*#__PURE__*/React.createElement(_Icon.ClickableIcon, {
    ariaLabel: "Select Previous Month",
    size: "small",
    name: "chevron-left",
    className: (0, _classify.default)(_DateRangeWrapperModule.default.headerIcon, {
      [_DateRangeWrapperModule.default.disabledIcon]: prevDisabled
    }),
    onClick: () => !prevDisabled && onClickPrevious(),
    color: prevDisabled ? 'disabled' : 'secondary'
  }), /*#__PURE__*/React.createElement(_Dropdown.Dropdown, {
    size: "small",
    disabled: !availableMonths.length || (0, _dateRangePicker.isAfter)(minDate, maxDate),
    menu: {
      selectedKeys: [_moment.default.utc(date).month().toString()],
      options: availableMonths
    },
    onChange: event => {
      setMonth((0, _utils.getMonthEndDate)(_moment.default.utc(date).set('M', event.key)));
    },
    dropdownInputText: _utils.MONTHS[_moment.default.utc(date).month()].label,
    scrollMenuToBottom: true
  }), /*#__PURE__*/React.createElement(_Dropdown.Dropdown, {
    disabled: !availableYears.length || (0, _dateRangePicker.isAfter)(minDate, maxDate),
    menu: {
      selectedKeys: [_moment.default.utc(date).year().toString()],
      options: availableYears
    },
    size: "small",
    onChange: event => {
      setMonth((0, _utils.getMonthEndDate)(_moment.default.utc(date).set('y', event.key)));
    },
    dropdownInputText: _moment.default.utc(date).year(),
    scrollMenuToBottom: true
  }), /*#__PURE__*/React.createElement(_Icon.ClickableIcon, {
    size: "small",
    ariaLabel: "Select Next Month",
    name: "chevron-right",
    className: (0, _classify.default)(_DateRangeWrapperModule.default.headerIcon, {
      [_DateRangeWrapperModule.default.disabledIcon]: nextDisabled
    }),
    onClick: () => !nextDisabled && onClickNext(),
    color: nextDisabled ? 'disabled' : 'secondary'
  }));
};
const DateRangeWrapper = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    onApply,
    onCancel,
    handlers,
    hoverDay,
    minDate,
    maxDate,
    timezone,
    dateRange,
    rangeStartMonth,
    setTimezone,
    rangeEndMonth,
    inHoverRange,
    setRangeStartMonth,
    setRangeEndMonth,
    cardWrapperClass,
    hideTimezone,
    today
  } = _ref2;
  const canNavigateCloser = _moment.default.utc(rangeStartMonth).year() !== _moment.default.utc(rangeEndMonth).year() || Math.abs(_moment.default.utc(rangeStartMonth).month() - _moment.default.utc(rangeEndMonth).month()) > 1;
  const handleApplyClick = () => {
    const {
      startDate,
      endDate
    } = dateRange;
    const startDateUTC = startDate && (0, _dateRangePicker.addTimezoneStartOfDay)(startDate, timezone);
    const endDateUTC = endDate && (0, _dateRangePicker.addTimezoneEndOfDay)(endDate, timezone);
    onApply({
      startDate,
      endDate,
      startDateUTC,
      endDateUTC,
      timezone
    });
  };
  const {
    onMonthNavigate
  } = handlers;
  const commonProps = {
    inHoverRange,
    handlers,
    hoverDay,
    dateRange,
    minDate,
    maxDate,
    today
  };
  return /*#__PURE__*/React.createElement(_FocusManager.FocusManager, null, /*#__PURE__*/React.createElement(_Card.Card, {
    classNames: {
      wrapper: (0, _classify.default)(_DateRangeWrapperModule.default.dateRangeWrapper, cardWrapperClass)
    },
    ref: ref
  }, /*#__PURE__*/React.createElement(_Card.CardHeader, {
    className: _DateRangeWrapperModule.default.cardHeader
  }, /*#__PURE__*/React.createElement(CalendarHeader, {
    marker: _utils.MARKERS.DATE_RANGE_START,
    rangeStartMonth: rangeStartMonth,
    rangeEndMonth: rangeEndMonth,
    date: rangeStartMonth,
    setMonth: setRangeStartMonth,
    nextDisabled: !canNavigateCloser,
    prevDisabled: (0, _dateRangePicker.isSameOrBefore)(rangeStartMonth, minDate, 'month'),
    minDate: minDate,
    maxDate: maxDate,
    onClickNext: () => onMonthNavigate(_utils.MARKERS.DATE_RANGE_START, _utils.NAVIGATION_ACTION.NEXT),
    onClickPrevious: () => onMonthNavigate(_utils.MARKERS.DATE_RANGE_START, _utils.NAVIGATION_ACTION.PREV)
  }), /*#__PURE__*/React.createElement(CalendarHeader, {
    marker: _utils.MARKERS.DATE_RANGE_END,
    rangeStartMonth: rangeStartMonth,
    rangeEndMonth: rangeEndMonth,
    date: rangeEndMonth,
    setMonth: setRangeEndMonth,
    nextDisabled: (0, _dateRangePicker.isSameOrAfter)(rangeEndMonth, maxDate, 'month'),
    prevDisabled: !canNavigateCloser,
    minDate: minDate,
    maxDate: maxDate,
    onClickNext: () => onMonthNavigate(_utils.MARKERS.DATE_RANGE_END, _utils.NAVIGATION_ACTION.NEXT),
    onClickPrevious: () => onMonthNavigate(_utils.MARKERS.DATE_RANGE_END, _utils.NAVIGATION_ACTION.PREV)
  })), /*#__PURE__*/React.createElement(_Card.CardContent, {
    className: _DateRangeWrapperModule.default.dateRangeCalendars
  }, /*#__PURE__*/React.createElement(_Calendar.Calendar, _extends({
    marker: _utils.MARKERS.DATE_RANGE_START,
    value: rangeStartMonth
  }, commonProps)), /*#__PURE__*/React.createElement("div", {
    className: _DateRangeWrapperModule.default.divider
  }), /*#__PURE__*/React.createElement(_Calendar.Calendar, _extends({
    marker: _utils.MARKERS.DATE_RANGE_END,
    value: rangeEndMonth
  }, commonProps))), /*#__PURE__*/React.createElement(_Card.CardFooter, null, /*#__PURE__*/React.createElement(_Card.CardTitle, {
    className: _DateRangeWrapperModule.default.timezoneDropdownContainer
  }, !hideTimezone && /*#__PURE__*/React.createElement(_Dropdown.SimpleDropdown, {
    options: (0, _utils.getTimezones)(),
    disabled: (0, _dateRangePicker.isAfter)(minDate, maxDate),
    classNames: {
      box: _DateRangeWrapperModule.default.timezoneDropdown
    },
    selectedKeys: [timezone],
    onChange: event => setTimezone(event.key),
    size: "small",
    menuVirtualization: {
      enable: true
    },
    allowSearch: true
  })), /*#__PURE__*/React.createElement(_Card.CardActions, null, /*#__PURE__*/React.createElement(_Button.Button, {
    type: "ghost",
    onClick: onCancel,
    size: "small"
  }, "Cancel"), /*#__PURE__*/React.createElement(_Button.Button, {
    onClick: handleApplyClick,
    size: "small",
    disabled: !(dateRange.startDate && dateRange.endDate)
  }, "Apply")))));
});
exports.DateRangeWrapper = DateRangeWrapper;